//import * as firebase from 'firebase';
import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";

// const config = {
//   apiKey: process.env.FIREBASE_API_KEY,
//   authDomain: process.env.FIREBASE_AUTH_DOMAIN,
//   databaseURL: process.env.FIREBASE_DATABASE_URL,
//   projectId: process.env.FIREBASE_PROJECT_ID,
//   storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.FIREBASE_APP_ID
// };

const config = {
  apiKey: "AIzaSyAopVMZKS8lbfr4WtSctf0LZhK7pdVANpU",
  authDomain: "trackitdemo.authfx.io",
  databaseURL: "https://track-it-d18c0-default-rtdb.firebaseio.com",
  projectId: "track-it-d18c0",
  storageBucket: "track-it-d18c0.appspot.com",
  messagingSenderId: "519603266234",
  appId: "1:519603266234:web:244f3fda25c6f7a0dfd883"
};

firebase.initializeApp(config);

const database = firebase.database();
const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const authFXAuthProvider = new firebase.auth.OAuthProvider('oidc.authfx');
authFXAuthProvider.addScope('profile');
authFXAuthProvider.addScope('email');
authFXAuthProvider.addScope('phone');

export { firebase, googleAuthProvider, authFXAuthProvider, database as default };


// child_removed
// database.ref('expenses')
//     .on('child_removed', (snapshot) => {
//         console.log(snapshot.key, snapshot.val());
//     });

// child_changed
// database.ref('expenses')
//     .on('child_changed', (snapshot) => {
//         console.log(snapshot.key, snapshot.val());
//     });

// child_added - Gets all existing plus runs when 
// a new item is added
// database.ref('expenses')
//     .on('child_added', (snapshot) => {
//         console.log(snapshot.key, snapshot.val());
//     });

// database.ref('expenses')
//     .once('value')
//     .then((snapshot) => {
//         const expenses = [];
//         snapshot.forEach((childSnapshot) => {
//             expenses.push({
//                 id: childSnapshot.key,
//                 ...childSnapshot.val()
//             });
//         });
//         console.log(expenses);
//     });

// database.ref('expenses')
//     .on('value', (snapshot) => {
//         const expenses = [];
//         snapshot.forEach((childSnapshot) => {
//             expenses.push({
//                 id: childSnapshot.key,
//                 ...childSnapshot.val()
//             });
//         });
//         console.log(expenses);
//     });

// database.ref('expenses').push({
//     description: 'Rent',
//     note: '',
//     amount: 250000,
//     createdAt: 1000
// });

// database.ref('expenses').push({
//     description: 'Coffee',
//     note: '',
//     amount: 2500,
//     createdAt: 6500
// });

// database.ref('expenses').push({
//     description: 'Food',
//     note: 'Lunch',
//     amount: 3541.25,
//     createdAt: 5500
// });

// database.ref('notes/-NP9ZNcwgnN7UGGDfGYQ').remove();

// Use .push() to create unique IDs for list type data
//
// database.ref('notes').push({
//     title: 'Course Topics',
//     body: 'Angular, React, Databases'
// });

// const firebaseNotes = {
//     notes: {
//         asdasd: {
//             title: 'First note',
//             body: 'This is my note'
//         },
//         asdfasdfa: {
//             title: 'Second note',
//             body: 'This is my note'
//         }
//     }
// }

// const notes = [{
//     id: '12',
//     title: 'First note',
//     body: 'This is my note'
// }, {
//     id: '761ase',
//     title: 'Another note',
//     body: 'This is my note'
// }];

// database.ref('notes').set(notes);

// database.ref().on('value', (snapshot) => {
//     const val = snapshot.val();
//     console.log(`${val.name} is a ${val.job.title} at ${val.job.company}.`)
// }, (e) => {
//     console.log("Error: ", e)
// });

// Using .on() watches the data and automatically
// runs again on a change.  .on() returns the function argument
// so we set this as a const that can be used in other places
// like in the .off() function.
//
// Add third argument, another function, to handle any errors
//
// const onValueChange = database.ref().on('value', (snapshot) => {
//         console.log(snapshot.val());
//     }, (e) => {
//         console.log('Error with data fetching'. e);
//     });

// setTimeout(() => {
//     database.ref('age').set(57);
// }, 3500);

// setTimeout(() => {
//    database.ref().off(onValueChange);
// }, 7000);


// setTimeout(() => {
//     database.ref('age').set(58);
// }, 10500);

// Using .once() uses promises as it is called only once.
//
// database.ref('location/city')
//     .once('value')
//     .then((snapshot) => {
//         const val = snapshot.val();
//         console.log(val);
//     }).catch((e) => {
//         console.log('Error fetching data', e)
//     });

// database.ref().set({
//     name: 'Scott Heger',
//     age: 54,
//     stressLevel: 8,
//     job: {
//         title: 'President',
//         company: 'IDFX Labs, Inc.'
//     },
//     location: {
//         city: 'Tampa',
//         country: 'United States'
//     }
// }).then(() => {
//     console.log('Data is saved');
// }).catch((e) => {
//     console.log('This failed.', e)
// });

// database.ref().update({
//     stressLevel: 9,
//     'job/company': 'Amazon',
//     'location/city': 'Seattle'
// });

// database.ref()
//     .remove()
//     .then(() => {
//         console.log("Data was removed.");
//     }).catch((e) => {
//         console.log('Did not remove data.', e)
//     });




// WEBPACK FOOTER //
// ./src/firebase/firebase.js